import { useEffect, useState } from "react";
import { Alert, Button, Stack, Tab, Tabs, Typography } from "@mui/material";
import CategoryManager from "../components/CategoryManager";
import { apiRequest } from "../utils/http";

const scopes = {
  RENTAL: { title: "Rental Categories", endpoint: "/api/admin/categories" },
  EVENT_PROP: { title: "Event Prop Categories", endpoint: "/api/admin/event-prop-categories" }
};

function ScopedCategories({ scope }) {
  const { title, endpoint } = scopes[scope];
  const [categories, setCategories] = useState([]);
  const [status, setStatus] = useState("loading");
  const [error, setError] = useState("");
  useEffect(() => {
    let current = true;
    apiRequest(endpoint, { cache: "no-store" }).then(response => {
      if (current) { setCategories(response.data || []); setStatus("ready"); }
    }).catch(e => { if (current) { setError(e.message); setStatus("error"); } });
    return () => { current = false; };
  }, [endpoint]);
  async function reload() {
    const response = await apiRequest(endpoint, { cache: "no-store" });
    setCategories(response.data || []); setStatus("ready"); setError("");
  }
  if (status === "loading") return <Typography role="status">Loading categories...</Typography>;
  if (status === "error") return <Alert severity="error">{error}<Button onClick={() => reload().catch(e => setError(e.message))}>Retry</Button></Alert>;
  return <CategoryManager categories={categories} onSaved={reload} endpoint={endpoint} title={title}
    description={`Scope: ${scope}. ${scope === "RENTAL" ? "Normal rental Products and the main Rentals dropdown." : "Separate Event Props catalogue only."} Active categories are available before products are assigned. Changes never reassign products; reassign items before deactivation.`} />;
}

export default function CategoriesPage() {
  const [scope, setScope] = useState("RENTAL");
  return <Stack spacing={3}>
    <Typography variant="h4">Categories</Typography>
    <Typography>Manage category names, visibility and display order separately for each catalogue.</Typography>
    <Tabs value={scope} onChange={(_, value) => setScope(value)} variant="scrollable" scrollButtons="auto" aria-label="Category scope">
      {Object.entries(scopes).map(([value, config]) => <Tab key={value} value={value} label={config.title} />)}
    </Tabs>
    <ScopedCategories key={scope} scope={scope} />
  </Stack>;
}
